import type { GroupSubscriptionData } from '../groupSubscriptionTypes';
import { GroupCardHeader } from './GroupCardHeader';

type CanceledGroupCardProps = {
  group: GroupSubscriptionData;
  translations?: Record<string, string>;
};

export function CanceledGroupCard({ group, translations }: CanceledGroupCardProps) {
  const canceledLabel = translations?.['group_subscriptions.card.canceled_badge'] ?? 'Canceled';

  return (
    <div className="flex flex-col gap-4 rounded-md border border-gray-200 bg-white p-4">
      <GroupCardHeader
        group={group}
        hideToggle
        endedAt={group.ends_at}
        showSeatCount
        translations={translations}
        rightSlot={
          <span className="inline-flex h-6 shrink-0 items-center self-start whitespace-nowrap rounded border border-red-200 bg-red-100 px-2 py-1 text-xs font-medium text-red-900">
            {canceledLabel}
          </span>
        }
      />
    </div>
  );
}
